
import React from 'react';
import { highlightMentions } from '@/utils/mentionUtils';

interface MessageContentProps {
  message: string;
  currentUsername?: string;
  className?: string;
}

const MessageContent = ({ message, currentUsername, className = '' }: MessageContentProps) => {
  console.log('🎨 Rendering message content:', {
    message: message.substring(0, 50),
    currentUsername,
    hasMentions: message.includes('@')
  });

  return (
    <div className={className}>
      {highlightMentions(message, currentUsername)}
    </div>
  );
};

export default MessageContent;
